import { BrowserRouter as Router, Routes , Route } from 'react-router-dom';
import "./App.css";
import Home from "./pages/home"
import Inventory from "./pages/inventory"
import Locations from './pages/locations';
import Items from './pages/items';
import HornNavbar from "./components/Navbar";

function App() {
  return (
    <Router>
      <HornNavbar />

      <div className="main-content">
      <Routes>
          <Route exact path="/" element={<Home/>} />
          <Route exact path="/inventory" element={<Inventory/>} />
          <Route exact path="/locations" element={<Locations/>} />
          <Route exact path="/items" element={<Items/>} />
        {/* </div> */}
      </Routes>
      </div>
    </Router>
  );
}

export default App;
